import React, { useState, useEffect } from "react";
import { Modal, Form, Input, Button, Row, Col, Typography, message, Popconfirm } from "antd";
import { platformApi } from "../../../../api";
import VehicleName from "../../../VehicleName";

const { Text } = Typography;
const { TextArea } = Input;

const FeedbackModal = (props) => {
  const { visible, onCancel, jobInvoice, onSaveSuccess } = props;
  const [feedback, setFeedback] = useState("");
  const [editable, setEditable] = useState(false);

  useEffect(() => {
    if (jobInvoice) {
      setFeedback(jobInvoice.jobInvoiceFeedback || "");
      setEditable(false);
    }
  }, [jobInvoice, visible]);

  // === Save feedback ===
  const handleSave = () => {
    if (!jobInvoice || !jobInvoice.id) return;
    platformApi
      .post("/api/jobInvoice/saveFeedback", {
        id: jobInvoice.id,
        customerFeedback: feedback,
      })
      .then((res) => {
        if (res.data.code === 200) {
          message.success("Feedback updated successfully");
          setEditable(false);
          if (onSaveSuccess) onSaveSuccess();
        } else {
          message.error("Unable to update feedback");
        }
      })
      .catch((err) => {
        message.error("Error updating feedback");
      });
  };

  // === Delete feedback ===
  const handleDelete = () => {
    if (!jobInvoice || !jobInvoice.id) return;
    platformApi
      .delete(`/api/jobInvoice/deleteFeedback/${jobInvoice.id}`)
      .then((res) => {
        if (res.data.code === 200) {
          message.success("Feedback deleted successfully");
          setFeedback("");
          setEditable(false);
          if (onSaveSuccess) onSaveSuccess();
        } else {
          message.error("Unable to delete feedback");
        }
      })
      .catch((err) => {
        message.error("Error deleting feedback");
      });
  };

  return (
    <Modal
      title="Customer Service Feedback"
      visible={visible}
      onCancel={onCancel}
      width={600}
      footer={[
        feedback ? (
          <Popconfirm
            key="delete"
            title="Are you sure you want to delete this feedback?"
            onConfirm={handleDelete}
            okText="Yes"
            cancelText="No"
          >
            <Button disabled={!editable} danger>
              Delete
            </Button>
          </Popconfirm>
        ) : null,
        !editable ? (
          <Button
            key="modify"
            type="primary"
            onClick={() => setEditable(true)}
            style={{ marginLeft: 8 }}
          >
            Modify
          </Button>
        ) : (
          <Button
            key="save"
            type="primary"
            onClick={handleSave}
            style={{ marginLeft: 8 }}
          >
            Save
          </Button>
        ),
      ]}
    >
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Text strong>Customer Name: </Text>
          <Text>{(jobInvoice && jobInvoice.partyName && jobInvoice.partyName.name) || "-"}</Text>
        </Col>
        <Col span={12}>
          <Text strong>Vehicle: </Text>
          <Text>
            <VehicleName
              nameOnly
              value={jobInvoice?.jobOrder?.vehicle?.vehicle}
              fallback="-"
            />
          </Text>
        </Col>
        <Col span={12}>
          <Text strong>Invoice No: </Text>
          <Text>{(jobInvoice && jobInvoice.invoiceNumber) || "-"}</Text>
        </Col>
        <Col span={12}>
          <Text strong>Chassis No: </Text>
          <Text>{(jobInvoice && jobInvoice.jobOrder && jobInvoice.jobOrder.vehicle && jobInvoice.jobOrder.vehicle.chassisNo) || "-"}</Text>
        </Col>
        <Col span={24} style={{ marginTop: "16px" }}>
          <Text strong>Feedback</Text>
          <TextArea
            rows={4}
            value={feedback}
            disabled={!editable}
            onChange={(e) => setFeedback(e.target.value)}
            style={{ marginTop: "8px" }}
          />
        </Col>
      </Row>
    </Modal>
  );
};

export default FeedbackModal;
